import * as firebase from "firebase/app";

/**
 * Get the current Firebase project ID
 */
export const getProjectId = (): string | undefined => {
    return firebase.app().options['projectId'] as string | undefined;
}

/**
 * Check if the current project is Australia ResHub (Vacenti)
 */
export const isAustraliaResHub = (): boolean => {
    const projectId = getProjectId();
    return projectId === 'reshub-aus-vacenti';
}

/**
 * Check if the current project is a specific project
 */
export const isProject = (projectName: string): boolean => {
    const projectId = getProjectId();
    return projectId === projectName;
}
